import DecisionsScreen from './DecisionsScreen';

export default DecisionsScreen;
